// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1ksfi","bigColWidth":"Table_bigColWidth__Y6cdr","biggerColWidth":"Table_biggerColWidth__nkx3G","row":"Table_row__ZCL75","col":"Table_col__2kOGS"};